<template>
	<!-- Navbar start -->
	<nav class="w-screen fixed bg-opacity-90 bg-white p-4 lg:px-20 flex justify-between z-50">
		<!-- Logo start -->
		<div class="h-full flex flex-row justify-center" logo>
			<router-link to="/" class="no-underline">
				<div>
					<img src="@/assets/logo_only.svg" alt="Logo" class="h-20 w-auto mb-2">
					<p class="text-[#132e63] tracking-widest font-semibold">VIRTUS</p>
					<p class="text-[#132e63] tracking-widest font-light">CONSULTING</p>
				</div>
			</router-link>
		</div>
		<!-- Logo end -->


		<!-- Toggler start -->
		<button role="menubar" class="md:hidden" @click="navToggle()">
			<i class="fa-solid fa-bars text-2xl"></i>
		</button>

		<!-- Toggler end -->



		<!-- Menu content start -->
		<section
			class="absolute left-0 right-0 translate-y-16 bg-opacity-90 bg-white md:bg-none md:bg-opacity-0 shadow hidden md:flex flex-col gap-4 items-center p-4 md:flex-row md:static md:shadow-none md:translate-y-0"
			role="menu" aria-expanded="false">
			<!-- Links start -->
			<td class="mx-4 text-[#132e63] home"><router-link to="/">{{ $t('navBar.home') }}</router-link></td>
			<td class="mx-4 text-[#132e63] about"><router-link to="/about">{{ $t('navBar.about') }}</router-link></td>
			<td class="mx-4 text-[#132e63] services"><router-link to="/services">{{ $t('navBar.services')
					}}</router-link></td>
			<td class="mx-4 text-[#132e63] contact btn custom-btn"><router-link to="/contact">{{ $t('navBar.contact')
					}}</router-link></td>

			<!-- Links end -->
			<!-- Language switcher start -->
			<div class="flex items-center gap-2 text-[#132e63]">
				<button @click="toggleLocale('en')" :class="{ 'font-bold': $i18n.locale === 'en' }">English</button> /
				<button @click="toggleLocale('es')" :class="{ 'font-bold': $i18n.locale === 'es' }">Español</button>
			</div>
			<!-- Language switcher end -->

		</section>
		<!-- Menu content end -->
	</nav>
	<!-- Navbar end -->
</template>

<script>

export default {
    methods: {
		// Toogle navbar mode 
        navToggle() {
			let menu = document.querySelector("[role='menu']");
			let isExpanded = menu.getAttribute('aria-expanded');
			menu.setAttribute('aria-expanded', !isExpanded);
			menu.classList.toggle('hidden');
			menu.classList.toggle('flex');
		},
		toggleLocale(locale) {
            this.$i18n.locale = locale;
        }
    }
}
</script>

<style scoped>

.logo {
	font-size: 1.2rem;
	color: #051328 !important;
}

.custom-btn {
    background-color: #132e63 !important;
    color: #f5f5f5;
}

.eslogan {
	font-family: 'serif','charm','tinos';
	font-size: 0.8rem;
}

</style>